import { FormGroup, FormControl, Validators } from "@angular/forms";

export var GipContractForm = new FormGroup({
  ID: new FormControl(),
  CONTRACT_NUMBER: new FormControl('', [Validators.required, Validators.maxLength(50)]),
  CONTRACT_NAME: new FormControl('', [Validators.required, Validators.maxLength(50)]),
  CONTRACT_EXPIRATION_DT: new FormControl('', Validators.required),
  MAX_SHAPE_SIZE: new FormControl('', [Validators.required, Validators.max(99999999999999999999999999999999999999)]),
  MAX_NO_MAPSHEET_REQ: new FormControl('', [Validators.required, Validators.max(9999999999)]),
  REQ_EXPIRATION_TIME: new FormControl('', [Validators.required, Validators.max(9999999999)]),
  DELIVERY_TYPE: new FormControl(),
  AUTO_REPRINT: new FormControl(),
  NOTE: new FormControl('', Validators.maxLength(255)),
});

export class GipContractModel {
  ID: string;
  CONTRACT_NUMBER: string;
  CONTRACT_NAME: string;
  CONTRACT_EXPIRATION_DT: Date;
  MAX_SHAPE_SIZE: number;
  MAX_NO_MAPSHEET_REQ: number;
  REQ_EXPIRATION_TIME: Date;
  DELIVERY_TYPE: string;
  AUTO_REPRINT: number;
  NOTE: string;

  fromFormGroupModel(formModel: FormGroup) {
    this.ID = formModel.controls["ID"].value;
    this.CONTRACT_NUMBER = formModel.controls["CONTRACT_NUMBER"].value;
    this.CONTRACT_NAME = formModel.controls["CONTRACT_NAME"].value;
    this.CONTRACT_EXPIRATION_DT = formModel.controls["CONTRACT_EXPIRATION_DT"].value;
    this.MAX_SHAPE_SIZE = formModel.controls["MAX_SHAPE_SIZE"].value;
    this.MAX_NO_MAPSHEET_REQ = formModel.controls["MAX_NO_MAPSHEET_REQ"].value;
    this.REQ_EXPIRATION_TIME = formModel.controls["REQ_EXPIRATION_TIME"].value;
    this.DELIVERY_TYPE = formModel.controls["DELIVERY_TYPE"].value;
    this.AUTO_REPRINT = formModel.controls["AUTO_REPRINT"].value;
    this.NOTE = formModel.controls["NOTE"].value;
  }

  getUpdateMap() {
    return new Map ([
      ["ID", `${this.ID}`],
    
    ]);
  }
}

export var GipContractFormatForm = new FormGroup({
  ID: new FormControl('', Validators.maxLength(10)),
  CONTRACT_ID: new FormControl('', Validators.maxLength(10)),
  CONTRACT_NUMBER: new FormControl('', Validators.maxLength(50)),
  CONTRACT_NAME: new FormControl('', Validators.maxLength(50)),
  FORMAT_ID: new FormControl('', Validators.required),
  ORDINAL: new FormControl('', Validators.max(99999)),
});

export class GipContractFormatModel {
  ID: string;
  CONTRACT_ID: string;
  FORMAT_ID: string;
  ORDINAL: string;

  fromFormGroupModel(formModel: FormGroup) {
    this.ID = formModel.controls["ID"].value;
    this.CONTRACT_ID = formModel.controls["CONTRACT_ID"].value;
    this.FORMAT_ID = formModel.controls["FORMAT_ID"].value;
    this.ORDINAL = formModel.controls["ORDINAL"].value;
  }

  getUpdateMap() {
    return new Map ([
      ["ID", `${this.ID}`],
    
    ]);
  }
}

export var GipContractScaleForm = new FormGroup({
  ID: new FormControl(),
  CONTRACT_ID: new FormControl('', [Validators.required, Validators.maxLength(10)]),
  CONTRACT_NUMBER: new FormControl('', [Validators.required, Validators.maxLength(50)]),
  CONTRACT_NAME: new FormControl('', Validators.maxLength(50)),
  SCALE: new FormControl('', Validators.required),
  OVERLAP: new FormControl('', [Validators.required, Validators.max(99999)]),
  ORDINAL: new FormControl('', Validators.max(99999)),
});

export class GipContractScaleModel {
  ID: string;
  CONTRACT_ID: string;
  SCALE: string;
  OVERLAP: string;
  ORDINAL: string;

  fromFormGroupModel(formModel: FormGroup) {
    this.ID = formModel.controls["ID"].value;
    this.CONTRACT_ID = formModel.controls["CONTRACT_ID"].value;
    this.SCALE = formModel.controls["SCALE"].value;
    this.ORDINAL = formModel.controls["ORDINAL"].value;
    this.OVERLAP = formModel.controls["OVERLAP"].value;
  }

  getUpdateMap() {
    return new Map ([
      ["ID", `${this.ID}`],
    
    ]);
  }
}

export var GipContractPrinterForm = new FormGroup({
  ID: new FormControl(),
  CONTRACT_ID: new FormControl('', [Validators.required, Validators.maxLength(10)]),
  CONTRACT_NUMBER: new FormControl('', Validators.maxLength(50)),
  CONTRACT_NAME: new FormControl('', Validators.maxLength(50)),
  GDR_PRINTERID: new FormControl('', Validators.maxLength(50)),
  G3E_ELNO: new FormControl('', Validators.required),
  SERVICE: new FormControl(),
  ORDINAL: new FormControl('', Validators.maxLength(99999)),
});

export class GipContractPrinterModel {
  ID: string;
  CONTRACT_ID: string;
  GDR_PRINTERID: string;
  G3E_ELNO: string;
  SERVICE: string;
  ORDINAL: string;

  fromFormGroupModel(formModel: FormGroup) {
    this.ID = formModel.controls["ID"].value;
    this.CONTRACT_ID = formModel.controls["CONTRACT_ID"].value;
    this.GDR_PRINTERID = formModel.controls["GDR_PRINTERID"].value;
    this.ORDINAL = formModel.controls["ORDINAL"].value;
    this.G3E_ELNO = formModel.controls["G3E_ELNO"].value;
    this.SERVICE = formModel.controls["SERVICE"].value;
  }

  getUpdateMap() {
    return new Map ([
      ["ID", `${this.ID}`],
    
    ]);
  }
}